module.exports = __webpack_public_path__ + "img/arrow.92973e90.png";